'use client';

import { Paywall } from '@/components/Paywall';
import TemplateVideoPlayer from './TemplateVideoPlayer';
import { createProjectFromTemplate } from '@/actions/templateActions';

interface Template {
  id: string;
  projectId: string;
  title: string;
  isPremium: boolean;
  meta: {
    previewVideo?: string;
    previewImage?: string;
  } | null;
}

interface TemplateCardProps {
  template: Template;
  isProUser: boolean;
}

export default function TemplateCard({
  template,
  isProUser,
}: TemplateCardProps) {
  const previewVideo = template.meta?.previewVideo;
  const previewImage = template.meta?.previewImage ?? '';
  if (!previewVideo) {
    return null;
  }

  const handleClick = async () => {
    if (!(template.isPremium && !isProUser)) {
      await createProjectFromTemplate({ projectId: template.projectId });
    }
  };

  const TemplateContent = (
    <div
      className="relative cursor-pointer rounded-xl ring-2 ring-primary/20 transition-all duration-300 ease-in-out hover:ring-primary/80"
      onClick={handleClick}
    >
      <TemplateVideoPlayer
        previewVideo={previewVideo}
        previewImage={previewImage}
      />

      {template.isPremium && (
        <span className="absolute -left-2 top-0 -rotate-12 cursor-pointer rounded-xl border-2 border-primary/60 bg-primary/50 px-2 font-bold uppercase text-white backdrop-blur-lg backdrop-contrast-200">
          Premium
        </span>
      )}

      <span className="absolute bottom-3 left-3 cursor-pointer rounded-xl border border-wave-dark bg-wave-dark/70 px-3 py-0.5 text-xs font-semibold uppercase text-white backdrop-blur-lg backdrop-contrast-200">
        {template.title}
      </span>
    </div>
  );
  if (template.isPremium && !isProUser) {
    return <Paywall>{TemplateContent}</Paywall>;
  }

  return TemplateContent;
}